import Form from 'react-bootstrap/Form';
import React, { useState } from 'react';
import { _eval } from "../utils";
import BaseField from './BaseField';

function RadioInput(props) {

    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('Format non valide');

    const handleChange = async (e) => {

        const size = e.target.files[0].size < props.data.maxSize;
        const re = new RegExp(props.data.pattern);
        const match = re.test(e.target.files[0].name);

        if (!match || !size) {
            if (!match)
                setErrorMessage('Le fichier ne correspond pas au format demandé.');
            if (!size)
                setErrorMessage('Le fichier est trop lourd. Poid maximum : ' + (props.data.maxSize / 1000 / 1000) + ' megabytes');
            setShowError(true);
            props.handleChange(props.data.sid, { value: '', validity: false });
            return;
        }

        // If file seems valid, send it to web service
        const fileLocation = await props.handleFileUpload(props.data.sid, e.target.files[0]);

        // If file is uploaded, send it to parent
        if(fileLocation)
            props.handleChange(props.data.sid, { value: fileLocation, validity: true });
    }


    return (
        <BaseField
            data={props.data}
            handleChange={props.handleChange}
            formData={props.formData}
        >
            <Form.Group>
                {props.data.label.length > 0 ?
                    <Form.Label htmlFor={`input-for-${props.data.sid}`}>
                        {props.data.label}
                        {props.data.required ?
                            <span className='text-danger'>&nbsp;*</span>
                            : null}
                    </Form.Label>
                    : null}
                <Form.Control
                    data-validity-selector={props.data.sid}
                    type="file"
                    required={props.data.required}
                    onChange={e => { handleChange(e) }}
                />

                {props.data.helper ?
                    <Form.Text id={`helper-for-${props.data.sid}`} muted dangerouslySetInnerHTML={{ __html: props.data.helper }} />
                    : null}

                {/* Field live check */}
                {props.data.error && showError ?
                    <div>
                        <Form.Text id={`error-for-${props.data.sid}`} className='text-danger'>
                            {props.data.error}
                        </Form.Text>
                    </div>
                    : null}

                {/* Field check validity on submit */}
                {!(props.data.error && showError) ?
                    <Form.Control.Feedback type="invalid">
                        {errorMessage}
                    </Form.Control.Feedback>
                    : null}

            </Form.Group>



        </BaseField>
    );
}

export default RadioInput;